export function currentWeekStartIso(): string {
  return weekStartFromDateInput(formatLocalDate(new Date()));
}

export function weekStartFromDateInput(value: string): string {
  const date = parseLocalDate(value);
  if (Number.isNaN(date.getTime())) return currentWeekStartIsoFallback();
  return formatLocalDate(startOfWeekMonday(date));
}

export function shiftWeek(weekStartOn: string, deltaWeeks: number): string {
  const date = parseLocalDate(weekStartOn);
  date.setDate(date.getDate() + 7 * deltaWeeks);
  return formatLocalDate(date);
}

export function currentWeekStartIsoFallback(): string {
  return formatLocalDate(startOfWeekMonday(new Date()));
}

export function parseLocalDate(value: string): Date {
  const [year, month, day] = value.split("-").map((part) => Number(part));
  if (!year || !month || !day) return new Date("invalid");
  return new Date(year, month - 1, day);
}

export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function startOfWeekMonday(date: Date): Date {
  const cloned = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const day = cloned.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  cloned.setDate(cloned.getDate() + diff);
  return cloned;
}
